export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const REVERT_LANGUAGE = 'REVERT_LANGUAGE';
